const ClientTypeEnum = {
  SALESMAN: 0,
  SUBMANAGER: 1,
  MANAGER: 2,
  REGIONAL_MANAGER: 3,
  REGIONAL_SUPERVISOR: 4,
};

const ClientTypeLabel = new Map([
  [ClientTypeEnum.SALESMAN, 'Vendedor'],
  [ClientTypeEnum.SUBMANAGER, 'Subgerente'],
  [ClientTypeEnum.MANAGER, 'Gerente'],
  [ClientTypeEnum.REGIONAL_MANAGER, 'Gerente Regional'],
  [ClientTypeEnum.REGIONAL_SUPERVISOR, 'Supervisor Regional'],
]);

export { ClientTypeEnum, ClientTypeLabel };
